import KatalLogger from '@amzn/katal-logger';

export const logger = new KatalLogger({
  url: 'https://59s4fmcc94.execute-api.us-west-2.amazonaws.com/prod/v1/log',
  maxLogLineSize: 10000, // default 5000
});
